/*
 * Copyright Huesik (c) 2019.
 */

import Vuex from 'vuex'
import Vue from 'vue'

import store from './store'
import actions from './actions'
import mutations from './mutations'
import getters from './getters'

import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex)

console.log(mutations)

export default new Vuex.Store({
  state: {
    ...store
  },

  getters: {
    // Here we will create a getter
    ...getters
  },

  mutations: {
    // Here we will create Jenny
    ...mutations
  },

  actions: {
    // Here we will create Larry
    ...actions
  },
  // PersistedState 쓰면 Vuex 스토어가 LocalStorage 로 들어가는데, 일부 데이터를 날리기 싫어서 이렇게 처리함
  // 전체 데이터를 LocalStorage 에 저장할 필요는 없어서 나중에 ReWork 해야함
  plugins: [createPersistedState()]
})
